import React from "react";

const AccSettings = () => {
    return <div>AccSettings</div>;
};

export default AccSettings;
